import * as React from 'react'
import { SVGProps } from 'react'

const SvgRingingLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 76 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.903 6H1.097C.49 6 0 5.16 0 4.127V1.873C0 .838.491 0 1.098 0h73.805C75.508 0 76 .838 76 1.873v2.254C76 5.16 75.508 6 74.903 6Z"
      fill="#4EBEA0"
    />
  </svg>
)

export default SvgRingingLine
